import { createSlice } from "@reduxjs/toolkit";
import { GetAllClaimPolls } from "./ClaimPollsApi";


const defaultFilters = {
    branch_id: '',
    polls_type: '',
    start_date: '',
    end_date: '',

}


const ClaimPollsSlice = createSlice({
    name: 'claimPolls',
    initialState: {
        claimPollsFilter: defaultFilters,
        claimPollsData: [],
    },
    reducers: {
        handleClaimPollsFilter: (state, action) => {
            state.claimPollsFilter[action?.payload?.check] = action?.payload?.value;
        },
        handleResetFilter: (state, _) => {
            state.claimPollsFilter = defaultFilters
        }
    },
    extraReducers: (builder) => {
        builder.addCase(GetAllClaimPolls.fulfilled, (state, action) => {
            state.claimPollsData = action?.payload?.data
        })
    }
});

export const { handleClaimPollsFilter, handleResetFilter } = ClaimPollsSlice.actions;
export default ClaimPollsSlice.reducer;

